import React from 'react';
import { useI18n } from '../i18n';
import { Check, Sparkles } from 'lucide-react';

export const Comparison: React.FC = () => {
  const { t } = useI18n();

  return (
    <section id="comparison" className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold-500/10 border border-gold-500/30 text-xs font-semibold text-gold-600 dark:text-gold-400 mb-4 uppercase tracking-wider">
            <span>{t.comparison.badge}</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight mb-4">
            {t.comparison.title}
          </h2>
          <p className="text-base text-slate-600 dark:text-slate-300">
            {t.comparison.subtitle}
          </p>
        </div>

        {/* Comparison Table */}
        <div className="overflow-x-auto rounded-2xl border border-slate-200 dark:border-navy-700/80 bg-white dark:bg-navy-950/60 shadow-surface">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-slate-200 dark:border-navy-800 bg-slate-100 dark:bg-navy-900/90 text-xs uppercase tracking-wider text-slate-700 dark:text-slate-400">
                <th className="py-4 px-6 font-semibold">{t.comparison.headers.feature}</th>
                <th className="py-4 px-6 font-semibold text-slate-600 dark:text-slate-400">{t.comparison.headers.direct}</th>
                <th className="py-4 px-6 font-semibold text-slate-600 dark:text-slate-400">{t.comparison.headers.genericWrapper}</th>
                <th className="py-4 px-6 font-bold text-gold-600 dark:text-gold-400 bg-gold-500/10 border-x border-gold-500/30">
                  <div className="flex items-center gap-1.5">
                    <Sparkles className="w-3.5 h-3.5 text-gold-500" />
                    <span>{t.comparison.headers.workouse}</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-navy-850 text-xs sm:text-sm">
              {t.comparison.rows.map((row, idx) => (
                <tr
                  key={idx}
                  className={`hover:bg-slate-50 dark:hover:bg-navy-900/40 transition-colors ${
                    row.highlight ? 'bg-slate-50/60 dark:bg-navy-900/20' : ''
                  }`}
                >
                  <td className="py-4 px-6 font-semibold text-slate-900 dark:text-white">
                    {row.feature}
                  </td>
                  <td className="py-4 px-6 text-slate-600 dark:text-slate-400 font-mono text-xs">
                    {row.direct}
                  </td>
                  <td className="py-4 px-6 text-slate-600 dark:text-slate-400 font-mono text-xs">
                    {row.genericWrapper}
                  </td>
                  <td className="py-4 px-6 font-bold text-gold-600 dark:text-gold-400 bg-gold-500/5 border-x border-gold-500/20 font-mono text-xs">
                    <div className="flex items-center gap-1.5">
                      <Check className="w-4 h-4 text-gold-500 shrink-0" />
                      <span>{row.workouse}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};
